"use client";
import o from "react";
import { loadStoryblokBridge as r } from "./storyblok-js.mjs";
const t = async (e) => {
  await r(), new window.StoryblokBridge(e).on(["published", "change"], () => {
    window.location.reload();
  });
}, i = ({ options: e }) => (t(e), /* @__PURE__ */ o.createElement(o.Fragment, null));
export {
  i as default
};
